import React from 'react';
import { Link } from 'react-router-dom';
import ContactSupport from './ContactSupport';

const Footer = () => {
  return (
    <footer className="bg-gray-50 py-12 px-6 border-t border-gray-100">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_ovalu-design/artifacts/231iio5y_1000063769.jpg"
                alt="Ovalu Logo"
                className="h-8 w-8 rounded-xl"
              />
              <span className="text-xl font-bold text-[#FF6B9D]">ovalu</span>
            </div>
            <p className="text-gray-600 text-sm">
              Empowering women through AI-powered health insights.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Product</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/about" className="hover:text-[#FF6B9D] transition-colors">About Ovalu</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Support</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/help" className="hover:text-[#FF6B9D] transition-colors">Help & Support</Link></li>
              <li>
                <Link to="/contact" className="hover:text-[#FF6B9D] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/privacy" className="hover:text-[#FF6B9D] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#FF6B9D] transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="hover:text-[#FF6B9D] transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 text-center text-gray-500 text-xs sm:text-sm">
          <p className="mb-2">© 2026 Ovalu. All rights reserved.</p>
          <p className="mb-1">Ovalu is a product of LabVIEWDevops.</p>
          <p className="mb-4">All payments are securely processed via Razorpay.</p>
          <div className="max-w-4xl mx-auto px-4 py-3 bg-gray-100/50 rounded-xl border border-gray-200/50">
            <p className="italic leading-relaxed">
              <strong>Disclaimer:</strong> Ovalu is not a medical or diagnostic application. It is intended for informational and cycle tracking purposes only. 
              The predictions and insights provided by the app may not be 100% accurate and should not be relied upon for medical decisions. 
              Users are advised to consult a qualified healthcare professional for any medical concerns.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
